export default __webpack_public_path__ + "static/media/image.e4896df6.png";